import { toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"
import _imports_0 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'
import _imports_1 from '@/app/ui/assets/svg/check-circle.svg'


const _hoisted_1 = { class: "flex flex-row mt-4 gap-x-4 p-6 rounded-xl border border-gray-lp-1300" }
const _hoisted_2 = { class: "relative mt-4" }
const _hoisted_3 = { class: "flex flex-row gap-2 items-center pb-1" }
const _hoisted_4 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_5 = { class: "flex flex-col gap-1 w-full" }
const _hoisted_6 = {
  class: "text-red-lp-100 bg-red-lp-50 rounded-md text-sm px-1.5 flex gap-x-1 items-center w-max mt-4",
  style: {"padding-top":"2px","padding-bottom":"2px"}
}
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Nomor telah melebihi ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" COD/DFOD per hari. ")
const _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  class: "font-normal text-12px text-black-lp-300 font-montserrat py-1 text-center",
  style: {"width":"322px"}
}, " Nomor handphone baru memiliki batas transaksi COD/DFOD per hari sebesar 10 STT (tidak termasuk CNX) atau total tarif STT melebihi Rp300.000 ", -1)
const _hoisted_11 = { class: "flex gap-x-2 pl-1 py-2 text-14px text-green-lp-400" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_13 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_14 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_15 = { class: "w-1/2 mr-4" }
const _hoisted_16 = { class: "p-field-checkbox mt-3" }
const _hoisted_17 = { class: "w-full mt-4" }
const _hoisted_18 = { class: "font-semibold text-gray-lp-600" }
const _hoisted_19 = { class: "relative mt-4" }
const _hoisted_20 = { class: "flex flex-row gap-2 items-center pb-1" }
const _hoisted_21 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_22 = { class: "flex flex-col gap-1 w-full" }
const _hoisted_23 = { class: "flex gap-x-2 pl-1 py-2 text-14px text-green-lp-400" }
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_25 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_26 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_27 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_28 = { class: "w-1/2 flex flex-col" }
const _hoisted_29 = { class: "flex flex-row" }
const _hoisted_30 = { class: "flex flex-row" }
const _hoisted_31 = { class: "mx-2" }
const _hoisted_32 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_33 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_34 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_35 = { class: "w-1/2 mr-4" }
const _hoisted_36 = { class: "p-field-checkbox mt-3" }
const _hoisted_37 = { class: "p-6 my-6 rounded-xl border border-gray-lp-1300 flex flex-col" }
const _hoisted_38 = { class: "flex flex-row items-center gap-x-2" }
const _hoisted_39 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M9 12C9 12.55 9.45 13 10 13H14C14.55 13 15 12.55 15 12C15 11.45 14.55 11 14 11H10C9.45 11 9 11.45 9 12Z",
    fill: "#A7A8AA"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.0002 3H7.00018C6.69018 3 6.39019 3.15 6.20019 3.4L3.20019 7.4C3.19368 7.40918 3.18733 7.41843 3.18113 7.42776C3.06709 7.59016 3 7.78763 3 8V20C3 20.55 3.45 21 4 21H20C20.55 21 21 20.55 21 20V8C21 7.93796 20.9943 7.8772 20.9833 7.81821C20.9568 7.66842 20.8958 7.52471 20.8002 7.4L17.8002 3.4C17.6102 3.15 17.3102 3 17.0002 3ZM18.0002 7L16.5002 5H13V7H18.0002ZM11 7V5H7.50018L6.00018 7H11ZM5 9H19V19H5V9Z",
    fill: "#A7A8AA"
  })
], -1)
const _hoisted_40 = { class: "grid grid-cols-3 gap-x-4 mt-6" }
const _hoisted_41 = { class: "flex flex-row items-center text-center justify-center gap-x-2" }
const _hoisted_42 = { class: "py-3 px-4 rounded-md bg-yellow-lp-400 flex flex-row items-center gap-x-3 mt-2" }
const _hoisted_43 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.23234 6.04104C9.12267 5.93075 8.98683 5.8505 8.8377 5.8079C8.68857 5.76531 8.5311 5.76178 8.38024 5.79766C8.22938 5.83354 8.09012 5.90763 7.97569 6.0129C7.86126 6.11817 7.77544 6.25113 7.72639 6.39917L5.22011 13.966L2.79938 16.403C2.28755 16.9183 2 17.6171 2 18.3459C2 19.0746 2.28755 19.7734 2.79939 20.2887C3.31122 20.804 4.00542 21.0935 4.72927 21.0935C5.45312 21.0935 6.14732 20.804 6.65916 20.2887L6.83928 20.1074L11.3983 22.4032C11.5691 22.4892 11.7625 22.519 11.9511 22.4882C12.1396 22.4574 12.3138 22.3676 12.4488 22.2316L13.0921 21.584C13.2627 21.4122 13.3586 21.1792 13.3586 20.9363C13.3586 20.6934 13.2627 20.4605 13.0921 20.2887L10.2732 17.4508L16.5961 15.3286C16.7432 15.2792 16.8753 15.1928 16.9798 15.0776C17.0844 14.9624 17.158 14.8222 17.1936 14.6703C17.2293 14.5185 17.2258 14.3599 17.1835 14.2098C17.1412 14.0597 17.0614 13.9229 16.9519 13.8125L9.23234 6.04104Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16.1691 7.37023C15.8138 7.01257 15.8138 6.43269 16.1691 6.07503L18.0989 4.13223C18.4542 3.77457 19.0302 3.77457 19.3854 4.13223C19.7407 4.48989 19.7407 5.06977 19.3854 5.42743L17.4556 7.37023C17.1003 7.72789 16.5243 7.72789 16.1691 7.37023Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.3622 5.95463C11.8769 5.82371 11.5889 5.32152 11.7189 4.83295L12.4253 2.17903C12.5553 1.69046 13.0542 1.40052 13.5395 1.53143C14.0248 1.66235 14.3128 2.16454 14.1827 2.65311L13.4764 5.30703C13.3463 5.7956 12.8475 6.08554 12.3622 5.95463Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.5751 11.2026C17.4451 10.7141 17.7331 10.2119 18.2184 10.0809L20.8546 9.36983C21.3399 9.23892 21.8387 9.52886 21.9688 10.0174C22.0988 10.506 21.8108 11.0082 21.3255 11.1391L18.6893 11.8502C18.204 11.9811 17.7052 11.6912 17.5751 11.2026Z",
    fill: "#F5A324"
  })
], -1)
const _hoisted_44 = { class: "text-14px font-medium font-montserrat text-yellow-lp-500" }
const _hoisted_45 = {
  key: 0,
  class: "w-full py-3 px-4 rounded-md bg-yellow-lp-400 flex flex-row items-center gap-x-4 mt-2"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.23234 6.04104C9.12267 5.93075 8.98683 5.8505 8.8377 5.8079C8.68857 5.76531 8.5311 5.76178 8.38024 5.79766C8.22938 5.83354 8.09012 5.90763 7.97569 6.0129C7.86126 6.11817 7.77544 6.25113 7.72639 6.39917L5.22011 13.966L2.79938 16.403C2.28755 16.9183 2 17.6171 2 18.3459C2 19.0746 2.28755 19.7734 2.79939 20.2887C3.31122 20.804 4.00542 21.0935 4.72927 21.0935C5.45312 21.0935 6.14732 20.804 6.65916 20.2887L6.83928 20.1074L11.3983 22.4032C11.5691 22.4892 11.7625 22.519 11.9511 22.4882C12.1396 22.4574 12.3138 22.3676 12.4488 22.2316L13.0921 21.584C13.2627 21.4122 13.3586 21.1792 13.3586 20.9363C13.3586 20.6934 13.2627 20.4605 13.0921 20.2887L10.2732 17.4508L16.5961 15.3286C16.7432 15.2792 16.8753 15.1928 16.9798 15.0776C17.0844 14.9624 17.158 14.8222 17.1936 14.6703C17.2293 14.5185 17.2258 14.3599 17.1835 14.2098C17.1412 14.0597 17.0614 13.9229 16.9519 13.8125L9.23234 6.04104Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16.1691 7.37023C15.8138 7.01257 15.8138 6.43269 16.1691 6.07503L18.0989 4.13223C18.4542 3.77457 19.0302 3.77457 19.3854 4.13223C19.7407 4.48989 19.7407 5.06977 19.3854 5.42743L17.4556 7.37023C17.1003 7.72789 16.5243 7.72789 16.1691 7.37023Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.3622 5.95463C11.8769 5.82371 11.5889 5.32152 11.7189 4.83295L12.4253 2.17903C12.5553 1.69046 13.0542 1.40052 13.5395 1.53143C14.0248 1.66235 14.3128 2.16454 14.1827 2.65311L13.4764 5.30703C13.3463 5.7956 12.8475 6.08554 12.3622 5.95463Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.5751 11.2026C17.4451 10.7141 17.7331 10.2119 18.2184 10.0809L20.8546 9.36983C21.3399 9.23892 21.8387 9.52886 21.9688 10.0174C22.0988 10.506 21.8108 11.0082 21.3255 11.1391L18.6893 11.8502C18.204 11.9811 17.7052 11.6912 17.5751 11.2026Z",
    fill: "#F5A324"
  })
], -1)
const _hoisted_47 = {
  key: 0,
  class: "text-14px font-medium font-montserrat text-yellow-lp-500"
}
const _hoisted_48 = {
  key: 1,
  class: "text-14px font-medium font-montserrat text-yellow-lp-500"
}
const _hoisted_49 = {
  key: 2,
  class: "text-14px font-medium font-montserrat text-yellow-lp-500"
}
const _hoisted_50 = { class: "flex flex-row w-full gap-x-6" }
const _hoisted_51 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-regular font-montserrat text-gray-lp-400" }, " Jika tidak diisi, tagihan COD akan mengikuti harga barang. ", -1)
const _hoisted_52 = { class: "`p-field-checkbox mt-4 text-left`" }
const _hoisted_53 = /*#__PURE__*/_createVNode("label", { class: 
                  `ml-2 text-px xxl:text-14px text-black-lp-100 font-normal`
                 }, " Asuransi Pengiriman ", -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "py-2 px-4 rounded-md bg-yellow-lp-400 flex flex-row items-center gap-x-4 mt-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.23234 6.04104C9.12267 5.93075 8.98683 5.8505 8.8377 5.8079C8.68857 5.76531 8.5311 5.76178 8.38024 5.79766C8.22938 5.83354 8.09012 5.90763 7.97569 6.0129C7.86126 6.11817 7.77544 6.25113 7.72639 6.39917L5.22011 13.966L2.79938 16.403C2.28755 16.9183 2 17.6171 2 18.3459C2 19.0746 2.28755 19.7734 2.79939 20.2887C3.31122 20.804 4.00542 21.0935 4.72927 21.0935C5.45312 21.0935 6.14732 20.804 6.65916 20.2887L6.83928 20.1074L11.3983 22.4032C11.5691 22.4892 11.7625 22.519 11.9511 22.4882C12.1396 22.4574 12.3138 22.3676 12.4488 22.2316L13.0921 21.584C13.2627 21.4122 13.3586 21.1792 13.3586 20.9363C13.3586 20.6934 13.2627 20.4605 13.0921 20.2887L10.2732 17.4508L16.5961 15.3286C16.7432 15.2792 16.8753 15.1928 16.9798 15.0776C17.0844 14.9624 17.158 14.8222 17.1936 14.6703C17.2293 14.5185 17.2258 14.3599 17.1835 14.2098C17.1412 14.0597 17.0614 13.9229 16.9519 13.8125L9.23234 6.04104Z",
      fill: "#F5A324"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.1691 7.37023C15.8138 7.01257 15.8138 6.43269 16.1691 6.07503L18.0989 4.13223C18.4542 3.77457 19.0302 3.77457 19.3854 4.13223C19.7407 4.48989 19.7407 5.06977 19.3854 5.42743L17.4556 7.37023C17.1003 7.72789 16.5243 7.72789 16.1691 7.37023Z",
      fill: "#F5A324"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.3622 5.95463C11.8769 5.82371 11.5889 5.32152 11.7189 4.83295L12.4253 2.17903C12.5553 1.69046 13.0542 1.40052 13.5395 1.53143C14.0248 1.66235 14.3128 2.16454 14.1827 2.65311L13.4764 5.30703C13.3463 5.7956 12.8475 6.08554 12.3622 5.95463Z",
      fill: "#F5A324"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.5751 11.2026C17.4451 10.7141 17.7331 10.2119 18.2184 10.0809L20.8546 9.36983C21.3399 9.23892 21.8387 9.52886 21.9688 10.0174C22.0988 10.506 21.8108 11.0082 21.3255 11.1391L18.6893 11.8502C18.204 11.9811 17.7052 11.6912 17.5751 11.2026Z",
      fill: "#F5A324"
    })
  ]),
  /*#__PURE__*/_createVNode("p", { class: "text-14px font-medium font-montserrat text-yellow-lp-500" }, " Pengiriman tanpa asuransi hanya dapat di klaim sebesar 10x ongkir / maksimal Rp2.000.000 ")
], -1)
const _hoisted_55 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_56 = { class: "w-full mt-6" }
const _hoisted_57 = { class: "w-full flex flex-row justify-between items-center" }
const _hoisted_58 = { class: "flex flex-row ml-1" }
const _hoisted_59 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_60 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_61 = { class: "flex flex-row ml-1" }
const _hoisted_62 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_63 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "py-2 px-4 rounded-md bg-yellow-lp-400 flex flex-row items-center gap-x-4 mt-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.23234 6.04104C9.12267 5.93075 8.98683 5.8505 8.8377 5.8079C8.68857 5.76531 8.5311 5.76178 8.38024 5.79766C8.22938 5.83354 8.09012 5.90763 7.97569 6.0129C7.86126 6.11817 7.77544 6.25113 7.72639 6.39917L5.22011 13.966L2.79938 16.403C2.28755 16.9183 2 17.6171 2 18.3459C2 19.0746 2.28755 19.7734 2.79939 20.2887C3.31122 20.804 4.00542 21.0935 4.72927 21.0935C5.45312 21.0935 6.14732 20.804 6.65916 20.2887L6.83928 20.1074L11.3983 22.4032C11.5691 22.4892 11.7625 22.519 11.9511 22.4882C12.1396 22.4574 12.3138 22.3676 12.4488 22.2316L13.0921 21.584C13.2627 21.4122 13.3586 21.1792 13.3586 20.9363C13.3586 20.6934 13.2627 20.4605 13.0921 20.2887L10.2732 17.4508L16.5961 15.3286C16.7432 15.2792 16.8753 15.1928 16.9798 15.0776C17.0844 14.9624 17.158 14.8222 17.1936 14.6703C17.2293 14.5185 17.2258 14.3599 17.1835 14.2098C17.1412 14.0597 17.0614 13.9229 16.9519 13.8125L9.23234 6.04104Z",
      fill: "#F5A324"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.1691 7.37023C15.8138 7.01257 15.8138 6.43269 16.1691 6.07503L18.0989 4.13223C18.4542 3.77457 19.0302 3.77457 19.3854 4.13223C19.7407 4.48989 19.7407 5.06977 19.3854 5.42743L17.4556 7.37023C17.1003 7.72789 16.5243 7.72789 16.1691 7.37023Z",
      fill: "#F5A324"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.3622 5.95463C11.8769 5.82371 11.5889 5.32152 11.7189 4.83295L12.4253 2.17903C12.5553 1.69046 13.0542 1.40052 13.5395 1.53143C14.0248 1.66235 14.3128 2.16454 14.1827 2.65311L13.4764 5.30703C13.3463 5.7956 12.8475 6.08554 12.3622 5.95463Z",
      fill: "#F5A324"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.5751 11.2026C17.4451 10.7141 17.7331 10.2119 18.2184 10.0809L20.8546 9.36983C21.3399 9.23892 21.8387 9.52886 21.9688 10.0174C22.0988 10.506 21.8108 11.0082 21.3255 11.1391L18.6893 11.8502C18.204 11.9811 17.7052 11.6912 17.5751 11.2026Z",
      fill: "#F5A324"
    })
  ]),
  /*#__PURE__*/_createVNode("p", { class: "text-14px font-medium font-montserrat text-yellow-lp-500" }, [
    /*#__PURE__*/_createTextVNode(" Harap isi komoditas dengan benar sesuai "),
    /*#__PURE__*/_createVNode("a", {
      href: "https://lionparcel.com/sk",
      target: "blank",
      class: " underline"
    }, "syarat & ketentuan"),
    /*#__PURE__*/_createTextVNode(" yang berlaku. ")
  ])
], -1)
const _hoisted_65 = { key: 3 }
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_67 = { class: "grid grid-cols-2 gap-x-4 mt-6 gap-y-4" }
const _hoisted_68 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_69 = {
  key: 4,
  class: "mb-8 mt-4"
}
const _hoisted_70 = {
  key: 5,
  class: "flex flex-col"
}
const _hoisted_71 = { class: "flex flex-col bg-gray-lp-700 mt-5 py-6 rounded-md" }
const _hoisted_72 = { class: "flex w-full gap-x-6 border-b border-gray-lp-400 py-5 flex-row gap-x-6text-black-lp-300 font-semibold text-12px xxl:text-14px" }
const _hoisted_73 = /*#__PURE__*/_createVNode("div", { class: "w-1/12 text-center" }, " No ", -1)
const _hoisted_74 = { class: "w-3/12" }
const _hoisted_75 = /*#__PURE__*/_createVNode("div", { class: "w-4/12" }, [
  /*#__PURE__*/_createTextVNode(" Dimensi/Paket "),
  /*#__PURE__*/_createVNode("span", { class: "font-normal text-gray-lp-500" }, " (P x L x T)"),
  /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*")
], -1)
const _hoisted_76 = /*#__PURE__*/_createVNode("div", { class: "w-2/12" }, " Berat Volume ", -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("div", { class: "w-2/12" }, null, -1)
const _hoisted_78 = { class: "flex w-full items-center gap-x-6 py-2 text-12px xxl:text-14px font-montserrat" }
const _hoisted_79 = { class: "w-1/12 text-center" }
const _hoisted_80 = { class: "w-3/12" }
const _hoisted_81 = { class: "w-4/12" }
const _hoisted_82 = { class: "w-2/12" }
const _hoisted_83 = {
  key: 0,
  class: "w-2/12"
}
const _hoisted_84 = {
  key: 1,
  class: "w-2/12"
}
const _hoisted_85 = { class: "flex w-full flex-row justify-start gap-x-6" }
const _hoisted_86 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_87 = { class: "w-9/12 flex flex-row px-4 py-2 rounded-md warningMinimumWeight ml-2 mr-32" }
const _hoisted_88 = { class: "text-gray-lp-300 text-12px font-normal" }
const _hoisted_89 = /*#__PURE__*/_createVNode("div", { class: "w-2/12" }, null, -1)
const _hoisted_90 = { class: "flex w-full flex-row justify-start gap-x-6" }
const _hoisted_91 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_92 = { class: "w-9/12 flex flex-row" }
const _hoisted_93 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_94 = { class: "text-red-lp-100 text-12px xxl:text-14px flex gap-x-2" }
const _hoisted_95 = /*#__PURE__*/_createVNode("div", { class: "w-2/12" }, null, -1)
const _hoisted_96 = {
  key: 0,
  class: "flex w-full flex-row justify-start gap-x-6"
}
const _hoisted_97 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_98 = /*#__PURE__*/_createVNode("div", { class: "w-9/12 flex flex-row" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "w-4.5 max-w-none",
    alt: "exclamation tiangle red"
  }),
  /*#__PURE__*/_createVNode("p", { class: "text-red-lp-100 text-12px xxl:text-14px flex gap-x-2" }, " Perubahan penurunan berat tidak diijinkan. ")
], -1)
const _hoisted_99 = /*#__PURE__*/_createVNode("div", { class: "w-2/12" }, null, -1)
const _hoisted_100 = { class: "my-5" }
const _hoisted_101 = {
  key: 6,
  class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2 pt-2"
}
const _hoisted_102 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_103 = { key: 0 }
const _hoisted_104 = { key: 1 }
const _hoisted_105 = {
  key: 7,
  class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2 pt-2"
}
const _hoisted_106 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_107 = /*#__PURE__*/_createVNode("span", null, " Maksimal Berat 5 Kg ", -1)
const _hoisted_108 = {
  key: 8,
  class: "flex flex-row justify-between text-12px xxl:text-14px px-6 my-6"
}
const _hoisted_109 = /*#__PURE__*/_createTextVNode(" Tambah Barang ")
const _hoisted_110 = {
  key: 0,
  class: "py-3 px-4 rounded-md bg-yellow-lp-400 flex flex-row items-center gap-x-4 mt-2"
}
const _hoisted_111 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.23234 6.04104C9.12267 5.93075 8.98683 5.8505 8.8377 5.8079C8.68857 5.76531 8.5311 5.76178 8.38024 5.79766C8.22938 5.83354 8.09012 5.90763 7.97569 6.0129C7.86126 6.11817 7.77544 6.25113 7.72639 6.39917L5.22011 13.966L2.79938 16.403C2.28755 16.9183 2 17.6171 2 18.3459C2 19.0746 2.28755 19.7734 2.79939 20.2887C3.31122 20.804 4.00542 21.0935 4.72927 21.0935C5.45312 21.0935 6.14732 20.804 6.65916 20.2887L6.83928 20.1074L11.3983 22.4032C11.5691 22.4892 11.7625 22.519 11.9511 22.4882C12.1396 22.4574 12.3138 22.3676 12.4488 22.2316L13.0921 21.584C13.2627 21.4122 13.3586 21.1792 13.3586 20.9363C13.3586 20.6934 13.2627 20.4605 13.0921 20.2887L10.2732 17.4508L16.5961 15.3286C16.7432 15.2792 16.8753 15.1928 16.9798 15.0776C17.0844 14.9624 17.158 14.8222 17.1936 14.6703C17.2293 14.5185 17.2258 14.3599 17.1835 14.2098C17.1412 14.0597 17.0614 13.9229 16.9519 13.8125L9.23234 6.04104Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16.1691 7.37023C15.8138 7.01257 15.8138 6.43269 16.1691 6.07503L18.0989 4.13223C18.4542 3.77457 19.0302 3.77457 19.3854 4.13223C19.7407 4.48989 19.7407 5.06977 19.3854 5.42743L17.4556 7.37023C17.1003 7.72789 16.5243 7.72789 16.1691 7.37023Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.3622 5.95463C11.8769 5.82371 11.5889 5.32152 11.7189 4.83295L12.4253 2.17903C12.5553 1.69046 13.0542 1.40052 13.5395 1.53143C14.0248 1.66235 14.3128 2.16454 14.1827 2.65311L13.4764 5.30703C13.3463 5.7956 12.8475 6.08554 12.3622 5.95463Z",
    fill: "#F5A324"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.5751 11.2026C17.4451 10.7141 17.7331 10.2119 18.2184 10.0809L20.8546 9.36983C21.3399 9.23892 21.8387 9.52886 21.9688 10.0174C22.0988 10.506 21.8108 11.0082 21.3255 11.1391L18.6893 11.8502C18.204 11.9811 17.7052 11.6912 17.5751 11.2026Z",
    fill: "#F5A324"
  })
], -1)
const _hoisted_112 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-medium font-montserrat text-yellow-lp-500" }, " Jenis pengiriman tidak tersedia karena terjadi embargo. ", -1)
const _hoisted_113 = {
  key: 1,
  class: "flex text-red-lp-100 gap-1 mt-2"
}
const _hoisted_114 = { class: "text-14px" }
const _hoisted_115 = {
  key: 2,
  class: "flex text-red-lp-100 gap-1 mt-2"
}
const _hoisted_116 = { class: "text-14px" }
const _hoisted_117 = {
  key: 0,
  class: "text-12px xxl:text-14px text-red-lp-700 border-b-2 border-gray-lp-400 mb-4 pb-4"
}
const _hoisted_118 = { class: "items-center justify-end flex flex-row" }
const _hoisted_119 = /*#__PURE__*/_createVNode("h2", { class: "text-14px pt-5 text-black-lp-300 font-bold" }, " Total Pembayaran ", -1)
const _hoisted_120 = { class: "flex items-center justify-center py-3" }
const _hoisted_121 = { class: "text-gray-lp-600 line-through text-14px mr-3" }
const _hoisted_122 = { class: "text-red-lp-100 font-bold text-18px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Title = _resolveComponent("Title")!
  const _component_SelectPhoneCountryV2 = _resolveComponent("SelectPhoneCountryV2")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_SelectCustomerV2 = _resolveComponent("SelectCustomerV2")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Card = _resolveComponent("Card")!
  const _component_EditCustomerForm = _resolveComponent("EditCustomerForm")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_InfoInsurance = _resolveComponent("InfoInsurance")!
  const _component_SectionGoodsCategory = _resolveComponent("SectionGoodsCategory")!
  const _component_Select = _resolveComponent("Select")!
  const _component_SectionAdditionalInfoInterpack = _resolveComponent("SectionAdditionalInfoInterpack")!
  const _component_InputDimension = _resolveComponent("InputDimension")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_SectionUploadPhotoForWeightAdjusment = _resolveComponent("SectionUploadPhotoForWeightAdjusment")!
  const _component_product_poster = _resolveComponent("product-poster")!
  const _component_DetailCalculation = _resolveComponent("DetailCalculation")!
  const _component_DetailUncalculation = _resolveComponent("DetailUncalculation")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_ModalV2, {
      width: "w-9/12",
      title: 
      `${
        _ctx.isCourierRecommendation
          ? _ctx.detailShipment.shipmentNoRefExt
          : _ctx.detailShipment.shipmentAlgoId
      }`
    ,
      onClose: () => _ctx.setEditTerminated(true)
    }, {
      content: _withCtx(() => [
        _withDirectives(_createVNode("div", null, _toDisplayString(_ctx.index), 513), [
          [_vShow, false]
        ]),
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_DataWrapper, {
            class: "w-full mr-4",
            label: "Shipment ID",
            tooltipTitle: "Shipment ID",
            tooltipDescription: "Isi Shipment ID dengan kode booking marketplace yang tertera pada paket (XYZ00xxx)."
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                class: "my-2",
                isFirstInput: true,
                disabled: true,
                modelValue: _ctx.shipmentList[_ctx.indexElement].shipmentAlgoId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].shipmentAlgoId = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            class: "w-full",
            label: _ctx.$t('bookingShipment.column.externalRefNumber')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.shipmentNoRefExt,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.shipmentNoRefExt = $event)),
                placeholder: "DOR00989",
                disabled: 
              _ctx.detailShipment.shipmentAlgoId.slice(0, 2) === 'DO'
                ? false
                : _ctx.disabledInput
            ,
                errorCaption: "Mohon isi No. Referensi Eksternal",
                showMaxLength: true,
                maxLength: 100
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Card, {
            rounded: "xl",
            class: "flex flex-col p-6",
            isShadow: false
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_Icons, { name: "icon-detail-sender" }),
                _createVNode(_component_Title, {
                  label: "Detail pengirim",
                  fontSize: 20
                })
              ]),
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('bookingShipment.column.shipperPhoneNumber')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectPhoneCountryV2, {
                        column: "Pengirim",
                        error: _ctx.errorPhoneSender,
                        phone: _ctx.shipmentList[_ctx.indexElement].shipmentSenderPhone,
                        code: _ctx.shipmentList[_ctx.indexElement].shipmentSenderPhoneCode,
                        isLoading: _ctx.isLoadingCustomer,
                        options: _ctx.senders,
                        onSetPhone: _ctx.setPhoneSender,
                        onSetPhoneCode: _ctx.setPhoneCodeSender,
                        onSetErrorPhoneCode: _ctx.setErrorPhoneCodeSender,
                        disabled: _ctx.handleDisabledInput,
                        onSetFieldIndex: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setFieldIndex(5))),
                        onEditItem: _ctx.editItemSender,
                        onSelectItem: _ctx.onChooseSenders
                      }, null, 8, ["error", "phone", "code", "isLoading", "options", "onSetPhone", "onSetPhoneCode", "onSetErrorPhoneCode", "disabled", "onEditItem", "onSelectItem"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _withDirectives(_createVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _withDirectives(_createVNode("span", null, [
                      _hoisted_8,
                      _createVNode("span", {
                        class: "hover:underline font-semibold cursor-pointer",
                        onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleTooltipHeader($event))),
                        onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleTooltipHeader($event)))
                      }, " limit transaksi ", 32),
                      _hoisted_9,
                      _createVNode(_component_OverlayPanel, {
                        ref: "opTooltip",
                        appendTo: "body"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }, 512)
                    ], 512), [
                      [_vShow, _ctx.errorMessageCodDfodFraud.limited]
                    ]),
                    _withDirectives(_createVNode("span", null, " Nomor ini memiliki tingkat retur COD/DFOD yang tinggi. ", 512), [
                      [_vShow, !_ctx.errorMessageCodDfodFraud.limited]
                    ])
                  ], 512), [
                    [_vShow, 
                  _ctx.errorMessageCodDfodFraud.limited ||
                    _ctx.errorMessageCodDfodFraud.suspected
                ]
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createTextVNode(" " + _toDisplayString(_ctx.errorPhoneSender.message), 1)
                  ], 512), [
                    [_vShow, _ctx.errorPhoneSender.success && _ctx.errorPhoneSender.message]
                  ])
                ]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('bookingShipment.column.shipperName'),
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectCustomerV2, {
                      placeholder: _ctx.$t('bookingShipment.placeholder.shipperName'),
                      error: 
                  _ctx.errorMandatory[3] ||
                    (_ctx.shipmentList[_ctx.indexElement].shipmentSenderName.length &&
                      _ctx.shipmentList[_ctx.indexElement].shipmentSenderName.length < 3)
                ,
                      customerName: 
                  _ctx.shipmentList[_ctx.indexElement].shipmentSenderName
                ,
                      "onUpdate:customerName": _cache[6] || (_cache[6] = ($event: any) => (
                  _ctx.shipmentList[_ctx.indexElement].shipmentSenderName
                 = $event)),
                      isLoading: _ctx.isLoadingCustomer,
                      options: _ctx.senders,
                      errorCaption: _ctx.errorMessageSenderName,
                      keyName: "customerPhoneNumber",
                      disabled: _ctx.handleDisabledInput,
                      onChange: _cache[7] || (_cache[7] = 
                  value => {
                    _ctx.fetchCustomer(value);
                  }
                ),
                      onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setFieldIndex(3))),
                      onSelectItem: _ctx.onChooseSenders,
                      onEditItem: _ctx.editItemSender
                    }, null, 8, ["placeholder", "error", "customerName", "isLoading", "options", "errorCaption", "disabled", "onSelectItem", "onEditItem"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('bookingShipment.column.shipperAddress'),
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      type: "textarea",
                      modelValue: _ctx.shipmentList[_ctx.indexElement].shipmentSenderAddress,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].shipmentSenderAddress = $event)),
                      error: 
                  _ctx.isShipperAndConsigneeAddressIdentical || _ctx.errorMandatory[7]
                ,
                      "error-caption": 
                  _ctx.errorMandatory[7]
                    ? 'Alamat pengirim wajib diisi'
                    : 'Alamat pengirim dan penerima tidak boleh sama'
                ,
                      disabled: _ctx.handleDisabledInput,
                      preventEnterTextArea: true,
                      format: _ctx.replaceNewLine,
                      placeholder: _ctx.$t('bookingShipment.placeholder.shipperAddress'),
                      maxLength: _ctx.maxAddressLength,
                      showMaxLength: true,
                      onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setFieldIndex(7)))
                    }, null, 8, ["modelValue", "error", "error-caption", "disabled", "format", "placeholder", "maxLength"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode(_component_Checkbox, {
                      id: "sender",
                      modelValue: _ctx.isSaveSender,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.isSaveSender = $event)),
                      binary: true,
                      onFocus: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onSaveCustomer($event, 'sender'))),
                      disabled: _ctx.disableSaveSender || _ctx.handleDisabledInput
                    }, null, 8, ["modelValue", "disabled"]),
                    _createVNode("label", {
                      class: "ml-2.5",
                      for: "sender",
                      style: 
                    `${
                      _ctx.disableSaveSender || _ctx.handleDisabledInput
                        ? `color:#9e9e9e`
                        : ''
                    }`
                  
                    }, "Simpan detail pengirim", 4)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_17, [
                (
                _ctx.getAccount.accountType === 'partner' ||
                  _ctx.getAccount.accountType === 'client'
              )
                  ? (_openBlock(), _createBlock(_component_Card, {
                      key: 0,
                      class: "flex flex-row p-3 bg-gray-lp-1000",
                      isShadow: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Icons, {
                          name: "location-gray",
                          class: "text-gray-lp-600 w-5 mr-2"
                        }),
                        _createVNode("div", _hoisted_18, _toDisplayString(_ctx.origin.name) + " - " + _toDisplayString(_ctx.origin.zipCode), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          (_ctx.isOpenUploadSender)
            ? (_openBlock(), _createBlock(_component_EditCustomerForm, {
                key: 0,
                isShown: _ctx.isOpenUploadSender,
                "onUpdate:isShown": _cache[13] || (_cache[13] = ($event: any) => (_ctx.isOpenUploadSender = $event)),
                customer: _ctx.selectedCustomer,
                onOnEditSuccess: _ctx.onChooseSenders
              }, null, 8, ["isShown", "customer", "onOnEditSuccess"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode(_component_Card, {
            rounded: "xl",
            class: "flex flex-col p-6",
            isShadow: false
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_20, [
                _createVNode(_component_Icons, { name: "icon-detail-sender" }),
                _createVNode(_component_Title, {
                  label: "Detail penerima",
                  fontSize: 20
                })
              ]),
              _createVNode("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('bookingShipment.column.recipientPhoneNumber')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectPhoneCountryV2, {
                        column: "Penerima",
                        error: _ctx.errorPhoneReceiver,
                        phone: _ctx.shipmentList[_ctx.indexElement].shipmentRecipientPhone,
                        code: _ctx.shipmentList[_ctx.indexElement].shipmentRecipientPhoneCode,
                        isLoading: _ctx.isLoadingCustomer,
                        options: _ctx.receivers,
                        onSetPhone: _ctx.setPhoneReceiver,
                        onSetPhoneCode: _ctx.setPhoneCodeReceiver,
                        onSetErrorPhoneCode: _ctx.setErrorPhoneCodeReceiver,
                        disabled: 
                    _ctx.isShipmentCASameday
                      ? _ctx.shipmentList[_ctx.indexElement].shipmentRecipientPhoneKeeped
                          .length
                      : _ctx.handleDisabledInput
                  ,
                        onSetFieldIndex: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setFieldIndex(6))),
                        onEditItem: _ctx.editItemReciever,
                        onSelectItem: _ctx.onChooseReceivers
                      }, null, 8, ["error", "phone", "code", "isLoading", "options", "onSetPhone", "onSetPhoneCode", "onSetErrorPhoneCode", "disabled", "onEditItem", "onSelectItem"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _withDirectives(_createVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createTextVNode(" " + _toDisplayString(_ctx.errorPhoneReceiver.message), 1)
                  ], 512), [
                    [_vShow, 
                  _ctx.errorPhoneReceiver.success && _ctx.errorPhoneReceiver.message
                ]
                  ])
                ]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('bookingShipment.column.recipientName'),
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectCustomerV2, {
                      placeholder: _ctx.$t('bookingShipment.placeholder.recipientName'),
                      error: 
                  _ctx.errorMandatory[4] ||
                    (_ctx.currentFieldIndex > 7 &&
                      _ctx.shipmentList[_ctx.indexElement].shipmentRecipientName.length &&
                      _ctx.shipmentList[_ctx.indexElement].shipmentRecipientName.length <
                        3)
                ,
                      customerName: 
                  _ctx.shipmentList[_ctx.indexElement].shipmentRecipientName
                ,
                      "onUpdate:customerName": _cache[15] || (_cache[15] = ($event: any) => (
                  _ctx.shipmentList[_ctx.indexElement].shipmentRecipientName
                 = $event)),
                      isLoading: _ctx.isLoadingCustomer,
                      options: _ctx.receivers,
                      errorCaption: _ctx.errorMessageRecipientName,
                      disabled: 
                  _ctx.isShipmentCASameday
                    ? _ctx.shipmentList[_ctx.indexElement].shipmentRecipientAddressKeeped
                        .length
                    : _ctx.handleDisabledInput
                ,
                      keyName: "customerPhoneNumber",
                      onFocus: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setFieldIndex(7))),
                      onChange: _cache[17] || (_cache[17] = 
                  value => {
                    _ctx.fetchCustomer(value);
                  }
                ),
                      onSelectItem: _ctx.onChooseReceivers,
                      onEditItem: _ctx.editItemReciever
                    }, null, 8, ["placeholder", "error", "customerName", "isLoading", "options", "errorCaption", "disabled", "onSelectItem", "onEditItem"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createVNode("div", _hoisted_25, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('bookingShipment.column.recipientAddress'),
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      type: "textarea",
                      disabled: 
                  _ctx.isShipmentCASameday
                    ? _ctx.shipmentList[_ctx.indexElement].shipmentRecipientAddressKeeped
                        .length
                    : _ctx.handleDisabledInput
                ,
                      modelValue: _ctx.shipmentList[_ctx.indexElement].shipmentRecipientAddress,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].shipmentRecipientAddress = $event)),
                      error: 
                  _ctx.isShipperAndConsigneeAddressIdentical || _ctx.errorMandatory[8]
                ,
                      "error-caption": 
                  _ctx.errorMandatory[8]
                    ? 'Alamat penerima wajib diisi'
                    : 'Alamat pengirim dan penerima tidak boleh sama'
                ,
                      preventEnterTextArea: true,
                      format: _ctx.replaceNewLine,
                      placeholder: 
                  _ctx.$t('bookingShipment.placeholder.recipientAddress')
                ,
                      maxLength: _ctx.maxAddressLength,
                      showMaxLength: true,
                      onFocus: _cache[19] || (_cache[19] = ($event: any) => (_ctx.setFieldIndex(8)))
                    }, null, 8, ["disabled", "modelValue", "error", "error-caption", "format", "placeholder", "maxLength"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createVNode("div", _hoisted_26, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('bookingShipment.column.districtDestinationCity'),
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectSearch, {
                      class: "mt-1.5",
                      isDisabled: 
                  _ctx.handleDisabledInput &&
                    _ctx.destination &&
                    _ctx.destination.id !== 0 &&
                    !_ctx.isHaveChosen
                ,
                      onFilter: _ctx.fetchDestinationCity,
                      isLoading: _ctx.isLoadingDestinationCity,
                      options: _ctx.destinationCityList,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: 
                  _ctx.$t('bookingShipment.placeholder.districtDestinationCity')
                ,
                      modelValue: _ctx.destination.name,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.destination.name = $event)),
                      onChange: _ctx.setDestination,
                      onFocus: _cache[21] || (_cache[21] = 
                  () => {
                    _ctx.fetchDestinationCity(_ctx.detailShipment.destination.name);
                    _ctx.setFieldIndex(9);
                  }
                ),
                      isShowErrorIndicator: 
                  _ctx.errorDestinationCity ||
                    _ctx.errorEmbargo.destinationCity ||
                    _ctx.destinationErrorDFOD ||
                    _ctx.errorMandatory[9]
                ,
                      errorCaption: 
                  _ctx.errorMandatory[9]
                    ? 'Kecamatan, Kota Tujuan wajib diisi'
                    : _ctx.destinationErrorDFOD
                    ? _ctx.errorMsgDestinationDfod
                    : ''
                ,
                      isShowErrorMessage: false
                    }, null, 8, ["isDisabled", "onFilter", "isLoading", "options", "placeholder", "modelValue", "onChange", "isShowErrorIndicator", "errorCaption"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('bookingShipment.column.postalCode'),
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    (typeof _ctx.shipmentList[_ctx.indexElement].postalCodeDestination === 'object')
                      ? (_openBlock(), _createBlock(_component_lp_input, {
                          key: 0,
                          modelValue: _ctx.shipmentList[_ctx.indexElement].postalCodeDestination.id,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].postalCodeDestination.id = $event)),
                          placeholder: _ctx.$t('bookingShipment.placeholder.postalCode'),
                          errorCaption: 
                  _ctx.currentFieldIndex > 9.5 && !_ctx.isValidPostalCodeDestination
                    ? 'Kode Pos wajib diisi'
                    : ''
                
                        }, null, 8, ["modelValue", "placeholder", "errorCaption"]))
                      : (_openBlock(), _createBlock(_component_lp_input, {
                          key: 1,
                          modelValue: _ctx.shipmentList[_ctx.indexElement].postalCodeDestination,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].postalCodeDestination = $event)),
                          placeholder: _ctx.$t('bookingShipment.placeholder.postalCode'),
                          errorCaption: 
                  _ctx.currentFieldIndex > 9.5 && !_ctx.isValidPostalCodeDestination
                    ? 'Kode Pos wajib diisi'
                    : ''
                
                        }, null, 8, ["modelValue", "placeholder", "errorCaption"]))
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createVNode("div", _hoisted_27, [
                _createVNode("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listAddressType, (item, index) => {
                      return (_openBlock(), _createBlock("label", {
                        key: index,
                        class: [
                    _ctx.isErrorSelectAddressType
                      ? 'radioCustomError'
                      : 'radioCustom'
                  , "relative block overflow-hidden"]
                      }, [
                        _createVNode("input", {
                          type: "radio",
                          value: _ctx.shipmentList[_ctx.indexElement].sttRecipientAddressType,
                          checked: 
                      _ctx.shipmentList[_ctx.indexElement].sttRecipientAddressType ===
                        item.value
                    ,
                          id: item,
                          onChange: ($event: any) => (_ctx.onSelectAddressType(item.name, item.value)),
                          name: "radio-input",
                          class: "w-full whitespace-no-wrap my-2 z-10 absolute"
                        }, null, 40, ["value", "checked", "id", "onChange"]),
                        _createVNode("div", _hoisted_30, [
                          _createVNode(_component_Icons, {
                            name: item.name === 'Rumah' ? 'home-type' : 'office',
                            class: "cursor-pointer ml-2 h-6"
                          }, null, 8, ["name"]),
                          _createVNode("span", _hoisted_31, _toDisplayString(item.name), 1)
                        ])
                      ], 2))
                    }), 128))
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingShipment.error.addressType")), 1)
                  ], 512), [
                    [_vShow, _ctx.isErrorSelectAddressType]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_34, [
                _createVNode("div", _hoisted_35, [
                  _createVNode("div", _hoisted_36, [
                    _createVNode(_component_Checkbox, {
                      id: "receiver",
                      modelValue: _ctx.isSaveReceiver,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.isSaveReceiver = $event)),
                      binary: true,
                      onFocus: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onSaveCustomer($event, 'receiver'))),
                      disabled: _ctx.disableSaveReceiver || _ctx.handleDisabledInput
                    }, null, 8, ["modelValue", "disabled"]),
                    _createVNode("label", {
                      class: "ml-2.5",
                      for: "receiver",
                      style: 
                    `${
                      _ctx.disableSaveReceiver || _ctx.handleDisabledInput
                        ? `color:#9e9e9e`
                        : ''
                    }`
                  
                    }, "Simpan detail penerima", 4)
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          (_ctx.isOpenUploadReciever)
            ? (_openBlock(), _createBlock(_component_EditCustomerForm, {
                key: 0,
                isShown: _ctx.isOpenUploadReciever,
                "onUpdate:isShown": _cache[26] || (_cache[26] = ($event: any) => (_ctx.isOpenUploadReciever = $event)),
                customer: _ctx.selectedCustomer,
                onOnEditSuccess: _ctx.onChooseReceivers,
                type: "receiver"
              }, null, 8, ["isShown", "customer", "onOnEditSuccess"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_37, [
          _createVNode("div", _hoisted_38, [
            _hoisted_39,
            _createVNode(_component_Title, {
              fontColor: "text-black",
              fontSize: 20,
              label: "Detail Barang & Jenis Pengiriman"
            })
          ]),
          _createVNode("div", _hoisted_40, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deliveryFeeTypes, (option) => {
              return (_openBlock(), _createBlock("div", {
                key: option.value,
                class: 
              `
                h-full
                rounded-xl
                py-1
                px-4
                font-montserrat
                cursor-pointer
                ${
                  _ctx.isTabActive(option.value)
                    ? 'border border-red-lp-300 bg-red-lp-50'
                    : option.disabled
                    ? 'bg-gray-lp-200 border border-gray-lp-1400 cursor-not-allowed'
                    : 'bg-white border border-gray-lp-1400'
                }
                flex
                justify-center
              `
            ,
                onClick: ($event: any) => (
              option.disabled ? null : _ctx.onChangeDeliveryFeeType(option.value)
            )
              }, [
                _createVNode("div", _hoisted_41, [
                  (option.logo)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: 
                  require(`@/app/ui/assets/svg/${option.logo}${
                    option.disabled ? '-inactive' : ''
                  }.svg`)
                ,
                        class: "max-w-none w-12 mr-2",
                        alt: "delivery-types"
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true),
                  _createVNode("p", {
                    class: 
                  `
                text-14px
                text-center
          ${option.disabled ? 'text-gray-lp-600' : 'text-black'}
                xxl:text-16px font-medium`
                
                  }, _toDisplayString(option.name), 3)
                ])
              ], 10, ["onClick"]))
            }), 128))
          ]),
          _withDirectives(_createVNode("div", _hoisted_42, [
            _hoisted_43,
            _createVNode("p", _hoisted_44, _toDisplayString(_ctx.errorMessageCodDfodFraud.blacklistDescription ||
                _ctx.errorMessageCodDfodFraud.limitedDescription), 1)
          ], 512), [
            [_vShow, 
            _ctx.errorMessageCodDfodFraud.blacklistDescription ||
              _ctx.shippingTypeFraudLimited
          ]
          ]),
          (
            !_ctx.getAccount.isCodBooking ||
              _ctx.codStatusDisabled ||
              _ctx.dfodStatusDisabled ||
              _ctx.deliveryFeeType === 'cod' ||
              _ctx.deliveryFeeType === 'dfod'
          )
            ? (_openBlock(), _createBlock("div", _hoisted_45, [
                _hoisted_46,
                (_ctx.codStatusDisabled || _ctx.dfodStatusDisabled)
                  ? (_openBlock(), _createBlock("p", _hoisted_47, _toDisplayString(!_ctx.getAccount.isCodBooking
                ? "POS Anda belum tersedia layanan COD, hubungi Admin Lion Parcel."
                : "Kota tujuan belum tersedia layanan COD atau DFOD."), 1))
                  : (
              (_ctx.deliveryFeeType === 'cod' || _ctx.deliveryFeeType === 'dfod') &&
                (!_ctx.codStatusDisabled || !_ctx.dfodStatusDisabled)
            )
                    ? (_openBlock(), _createBlock("p", _hoisted_48, _toDisplayString(_ctx.deliveryFeeType === "cod"
                ? _ctx.infoMessageDetailGoods[0]
                : _ctx.infoMessageDetailGoods[1]), 1))
                    : (_openBlock(), _createBlock("p", _hoisted_49, _toDisplayString(_ctx.codStatusDisabled && _ctx.dfodStatusDisabled
                ? "Kota tujuan belum tersedia layanan COD atau DFOD"
                : "Kota tujuan belum tersedia layanan COD atau DFOD."), 1))
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", {
            class: ["flex gap-x-6 mt-6 relative w-full", _ctx.deliveryFeeType !== 'cod' ? 'flex-row' : 'flex-col']
          }, [
            _createVNode("div", _hoisted_50, [
              _createVNode(_component_DataWrapper, {
                class: "w-full",
                label: _ctx.$t('bookingShipment.column.itemPrice'),
                fontSize: 14
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.estimationPrice,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.estimationPrice = $event)),
                    prefix: "IDR",
                    format: _ctx.formatEstimationPrice,
                    onKeydown: _cache[28] || (_cache[28] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                    disabled: _ctx.estimastionColumnDisable || _ctx.handleDisabledInput,
                    placeholder: "e.g 20.000",
                    onChange: _ctx.fullFilledCOD,
                    errorIcon: false,
                    error: _ctx.errorMandatory[13] || _ctx.errorEstimationPrice,
                    errorCaption: 
                  _ctx.errorEstimationPrice
                    ? `${_ctx.errMsgPrice}`
                    : 'Harga barang wajib diisi'
                ,
                    onFocus: _cache[29] || (_cache[29] = ($event: any) => (_ctx.setFieldIndex(13)))
                  }, null, 8, ["modelValue", "format", "disabled", "onChange", "error", "errorCaption"])
                ]),
                _: 1
              }, 8, ["label"]),
              _withDirectives(_createVNode(_component_DataWrapper, {
                class: "w-full",
                label: _ctx.$t('bookingShipment.column.codFeeOptional'),
                optional: true,
                fontSize: 14
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.codAmount,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.codAmount = $event)),
                    prefix: "IDR",
                    format: _ctx.formatEstimationPrice,
                    onKeydown: _cache[31] || (_cache[31] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                    disabled: _ctx.estimastionColumnDisable || _ctx.handleDisabledInput || _ctx.isShipmentAPAS,
                    placeholder: _ctx.$t('bookingShipment.placeholder.codFee'),
                    onFocus: _cache[32] || (_cache[32] = ($event: any) => (_ctx.setFieldIndex(13)))
                  }, null, 8, ["modelValue", "format", "disabled", "placeholder"]),
                  _hoisted_51
                ]),
                _: 1
              }, 8, ["label"]), [
                [_vShow, _ctx.deliveryFeeType === 'cod']
              ])
            ]),
            _createVNode(_component_DataWrapper, {
              class: "w-full",
              fontSize: 14,
              label: _ctx.$t('bookingShipment.column.insurance'),
              tooltipTitle: _ctx.$t('bookingShipment.tooltip.insurance'),
              tooltipDescription: _ctx.$t('bookingShipment.tooltip.insuranceMsg')
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_52, [
                  _createVNode(_component_Checkbox, {
                    id: "insurance",
                    modelValue: _ctx.isInsuranceBasic,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.isInsuranceBasic = $event)),
                    key: _ctx.isInsuranceBasic,
                    onChange: _ctx.onChangeInsurance,
                    binary: true,
                    disabled: 
                  !_ctx.isShipmentInsuranceEnable ||
                    _ctx.disabledInsurance ||
                    _ctx.disabled5Million
                
                  }, null, 8, ["modelValue", "onChange", "disabled"]),
                  _hoisted_53
                ]),
                _hoisted_54
              ]),
              _: 1
            }, 8, ["label", "tooltipTitle", "tooltipDescription"])
          ], 2),
          (_ctx.isShipmentCa)
            ? (_openBlock(), _createBlock("div", _hoisted_55, [
                _createVNode(_component_InfoInsurance, {
                  modelValue: _ctx.formData,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.formData = $event)),
                  bannerType: _ctx.deliveryFeeType,
                  commission: _ctx.insuranceDetail?.commissionPos,
                  profit: _ctx.insuranceProfit,
                  maxProtection: _ctx.insuranceDetail?.maxProtection,
                  cost: _ctx.insuranceDetail?.cost,
                  estimationPrice: _ctx.estimationPrice
                }, null, 8, ["modelValue", "bannerType", "commission", "profit", "maxProtection", "cost", "estimationPrice"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.enabledCommodityT1B1B2TKP01)
            ? (_openBlock(), _createBlock(_component_SectionGoodsCategory, {
                key: 2,
                goodsNames: _ctx.goodsName
              }, null, 8, ["goodsNames"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_56, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('bookingShipment.column.commodity'),
              fontSize: 14
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectSearch, {
                  id: "select-search_komoditas_edit-shipment-booking-aplikasi",
                  class: "mt-1.5",
                  isDisabled: 
                _ctx.enabledCommodityT1B1B2TKLP ? false : _ctx.handleDisabledInput
              ,
                  options: _ctx.commodities,
                  isLoading: _ctx.isLoadingCommodity,
                  onFilter: _ctx.fetchCommodityList,
                  keyName: "name",
                  keyValue: "code",
                  placeholder: _ctx.$t('bookingShipment.placeholder.commodity'),
                  modelValue: _ctx.shipmentList[_ctx.indexElement].shipmentCommodityName,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].shipmentCommodityName = $event)),
                  isShowErrorMessage: false,
                  isShowErrorIndicator: 
                _ctx.isErrorCommodity || _ctx.errorEmbargo.comodity || _ctx.errorMandatory[10]
              ,
                  errorCaption: 
                _ctx.isErrorCommodity
                  ? `Komoditas ini tidak aktif`
                  : _ctx.errorMandatory[10]
                  ? `Komoditas wajib diisi`
                  : ''
              ,
                  maxHeight: "270px",
                  onFocus: _cache[36] || (_cache[36] = 
                () => {
                  _ctx.getCommodityList();
                  _ctx.setFieldIndex(10);
                }
              ),
                  onChange: _cache[37] || (_cache[37] = 
                ($event) => {
                  _ctx.checkIsEmbargo($event);
                  _ctx.onUpdateEmbargoStatusFail();
                  _ctx.setHwsCommodity();
                }
              ),
                  useInfiniteScroll: "",
                  onScrolled: _ctx.fetchCommodityListInfiniteScroll,
                  idInput: "commodity-booking",
                  autoUpDown: ""
                }, {
                  "custom-option": _withCtx(({item}) => [
                    _createVNode("div", _hoisted_57, [
                      _createVNode("div", null, _toDisplayString(item.name), 1),
                      _createVNode("div", _hoisted_58, [
                        (item.isQuarantine)
                          ? (_openBlock(), _createBlock("span", _hoisted_59, " K "))
                          : _createCommentVNode("", true),
                        (item.isDangerousGoods)
                          ? (_openBlock(), _createBlock("span", _hoisted_60, " DG "))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  "selected-info": _withCtx(({selected}) => [
                    _createVNode("div", _hoisted_61, [
                      (selected && selected.isQuarantine)
                        ? (_openBlock(), _createBlock("span", _hoisted_62, " K "))
                        : _createCommentVNode("", true),
                      (selected && selected.isDangerousGoods)
                        ? (_openBlock(), _createBlock("span", _hoisted_63, " DG "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["isDisabled", "options", "isLoading", "onFilter", "placeholder", "modelValue", "isShowErrorIndicator", "errorCaption", "onScrolled"]),
                _hoisted_64
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          (_ctx.isFtzAccount)
            ? (_openBlock(), _createBlock("div", _hoisted_65, [
                _hoisted_66,
                _createVNode(_component_Title, {
                  fontSize: "20",
                  label: _ctx.$t('bookingShipment.column.crossBorderInformation'),
                  fontColor: "text-gray-lp-300",
                  hint: "(Khusus area BATAM)"
                }, null, 8, ["label"]),
                _createVNode("div", _hoisted_67, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('bookingShipment.column.taxIdentificationNumber'),
                    tooltipTitle: _ctx.$t('bookingShipment.tooltip.tax'),
                    tooltipDescription: _ctx.$t('bookingShipment.tooltip.taxMsg'),
                    fontSize: 14
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        modelValue: _ctx.shipmentList[_ctx.indexElement].shipmentNpwpNumber,
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].shipmentNpwpNumber = $event)),
                        format: _ctx.formatted,
                        onChange: _ctx.validateTaxNumber,
                        errorCaption: "Masukan No. Registrasi Pajak (NPWP) dengan benar",
                        error: _ctx.error.taxNumber,
                        placeholder: "00.000.000.0-000.000",
                        maxLength: "20",
                        "show-max-length": "",
                        onBlur: _ctx.handleErrorTaxNumber,
                        onFocus: _cache[39] || (_cache[39] = ($event: any) => (_ctx.setFieldIndex(14)))
                      }, null, 8, ["modelValue", "format", "onChange", "error", "onBlur"])
                    ]),
                    _: 1
                  }, 8, ["label", "tooltipTitle", "tooltipDescription"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('bookingShipment.column.shipmentStatus'),
                    tooltipTitle: _ctx.$t('bookingShipment.tooltip.shipmentStatus'),
                    tooltipDescription: 
                _ctx.$t('bookingShipment.tooltip.shipmentStatusMsg')
              ,
                    fontSize: 14
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Select, {
                        onOpenSelect: 
                  () => {
                    _ctx.onOpenSelect();
                    _ctx.setFieldIndex(11);
                  }
                ,
                        onCloseSelect: _ctx.onCloseSelect,
                        isOpenMenu: _ctx.isStatusGoods,
                        value: _ctx.shipmentList[_ctx.indexElement].shipmentGoodsStatus,
                        onChooseSelect: _ctx.onSelectStatus,
                        dataSelect: _ctx.listStatusGoods,
                        class: "w-full whitespace-no-wrap my-1.5 z-10",
                        isDisabled: false
                      }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                    ]),
                    _: 1
                  }, 8, ["label", "tooltipTitle", "tooltipDescription"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('bookingShipment.column.piecePerPack'),
                    tooltipTitle: _ctx.$t('bookingShipment.tooltip.shipmentStatus'),
                    tooltipDescription: 
                _ctx.$t('bookingShipment.tooltip.shipmentStatusMsg')
              ,
                    fontSize: 14
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        modelValue: _ctx.shipmentList[_ctx.indexElement].piecePerPack,
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].piecePerPack = $event)),
                        format: _ctx.formatPiecePerPack,
                        placeholder: "Masukan piece per pack"
                      }, null, 8, ["modelValue", "format"])
                    ]),
                    _: 1
                  }, 8, ["label", "tooltipTitle", "tooltipDescription"]),
                  _createVNode(_component_DataWrapper, {
                    label: "Komoditas Selanjutnya",
                    tooltipTitle: "Komoditas Selanjutnya",
                    tooltipDescription: "Isi dengan komoditas barang yang ada dalam satu koli.",
                    fontSize: 14
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        modelValue: _ctx.shipmentList[_ctx.indexElement].nextCommodity,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.shipmentList[_ctx.indexElement].nextCommodity = $event)),
                        placeholder: "Masukan komoditas selanjutnya"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_68
              ]))
            : _createCommentVNode("", true),
          (_ctx.eligibleAdditionalInfo)
            ? (_openBlock(), _createBlock("hr", _hoisted_69))
            : _createCommentVNode("", true),
          (_ctx.eligibleAdditionalInfo)
            ? (_openBlock(), _createBlock("div", _hoisted_70, [
                _createVNode(_component_SectionAdditionalInfoInterpack, {
                  modelValue: _ctx.additionalInfo,
                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.additionalInfo = $event)),
                  error: _ctx.errAditionalInfo,
                  photos: _ctx.getAdditionalInfoPhotos,
                  disabled: !_ctx.isShipmentFavorite
                }, null, 8, ["modelValue", "error", "photos", "disabled"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_DataWrapper, {
            label: "Berat barang",
            class: "w-full my-6"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_71, [
                _createVNode("div", _hoisted_72, [
                  _hoisted_73,
                  _createVNode("div", _hoisted_74, [
                    _createVNode(_component_DataWrapper, {
                      label: "Berat Barang",
                      suffix: "Kg",
                      tooltipTitle: "Berat Barang (Kg)",
                      tooltipDescription: "Minimum berat barang adalah 1 Kg. Masukan desimal dengan “,” bila dibutuhkan.",
                      isDefault: false
                    })
                  ]),
                  _hoisted_75,
                  _hoisted_76,
                  _hoisted_77
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listKGs, (key, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: index,
                    class: "flex flex-col"
                  }, [
                    _createVNode("div", _hoisted_78, [
                      _createVNode("div", _hoisted_79, _toDisplayString(index + 1), 1),
                      _createVNode("div", _hoisted_80, [
                        _createVNode(_component_lp_input, {
                          modelValue: key.grossWeight,
                          "onUpdate:modelValue": [($event: any) => (key.grossWeight = $event), _ctx.setValidateHWS],
                          error: _ctx.isDecreaseWeightNotAllowed || _ctx.errorEmbargo.weightStatus,
                          format: _ctx.formatFloat,
                          onChange: ($event: any) => (_ctx.onUpdateEmbargoStatusFail($event, index)),
                          placeholder: "e.g 20",
                          maxLength: _ctx.isMaxLengthGrossWeight,
                          isErrorIconInput: false,
                          isErrorIconCaption: false,
                          disabled: 
                      _ctx.isPrintAble ||
                        _ctx.isShipmentMp ||
                        _ctx.configDisableC1 ||
                        _ctx.disabledWeightAdjustment ||
                        _ctx.isShipmentCASameday
                    ,
                          onFocus: _cache[43] || (_cache[43] = ($event: any) => (_ctx.setFieldIndex(14))),
                          onOnClickViewDisabledInput: ($event: any) => (_ctx.onClickWeightAdjustment(index)),
                          showViewDisabledInput: _ctx.disabledWeightAdjustment
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "format", "onChange", "maxLength", "disabled", "onOnClickViewDisabledInput", "showViewDisabledInput"])
                      ]),
                      _createVNode("div", _hoisted_81, [
                        _createVNode(_component_InputDimension, {
                          length: key.dimension.length,
                          "onUpdate:length": ($event: any) => (key.dimension.length = $event),
                          width: key.dimension.width,
                          "onUpdate:width": ($event: any) => (key.dimension.width = $event),
                          height: key.dimension.height,
                          "onUpdate:height": ($event: any) => (key.dimension.height = $event),
                          onInput: ($event: any) => (_ctx.calculationVolumeWeight(index)),
                          onOnClickViewDisabledInput: ($event: any) => (_ctx.onClickWeightAdjustment(index)),
                          disabled: 
                      _ctx.isPrintAble ||
                        key.isDimensionDisabled ||
                        _ctx.isShipmentMp ||
                        _ctx.configDisableC1 ||
                        _ctx.disabledWeightAdjustment ||
                        _ctx.isShipmentCASameday
                    ,
                          error: _ctx.errorEmbargo.lengthStatus,
                          withIcon: false,
                          errorCaption: "Berat melebihi batas",
                          onChange: _ctx.onUpdateEmbargoStatusFail,
                          onFocus: _cache[44] || (_cache[44] = ($event: any) => (_ctx.setFieldIndex(14)))
                        }, null, 8, ["length", "onUpdate:length", "width", "onUpdate:width", "height", "onUpdate:height", "onInput", "onOnClickViewDisabledInput", "disabled", "error", "onChange"])
                      ]),
                      _createVNode("div", _hoisted_82, _toDisplayString(key.convertVolumeWeight) + " Kg ", 1),
                      (
                    _ctx.dataDetailShipmentBooking?.config?.adjustPieceRemove
                      ?.rule == 'EDITABLE' && _ctx.listKGs.length > 1 && !_ctx.disabledWeightAdjustment
                  )
                        ? (_openBlock(), _createBlock("div", _hoisted_83, [
                            _createVNode("div", {
                              onClick: ($event: any) => (_ctx.removeKGs(index)),
                              class: "self-center cursor-pointer ml-3 relative"
                            }, [
                              _createVNode("div", {
                                class: "h-4 xxl:h-5 ml-2 img-close-icon",
                                onMouseenter: ($event: any) => (_ctx.isHoverEnter(index)),
                                onMouseleave: _cache[45] || (_cache[45] = ($event: any) => (_ctx.isHoverDelete = false))
                              }, [
                                _withDirectives(_createVNode(_component_Tooltip, {
                                  message: "Hapus Barang",
                                  title: "",
                                  footer: "",
                                  style: {"width":"135px","margin-left":"1.5em","margin-top":"-1.3em"}
                                }, null, 512), [
                                  [_vShow, _ctx.isHoverDelete && index === _ctx.cacheIndex]
                                ])
                              ], 40, ["onMouseenter"])
                            ], 8, ["onClick"])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_84, [
                            _withDirectives(_createVNode("div", {
                              onClick: ($event: any) => (_ctx.removeKGs(index)),
                              class: "self-center cursor-pointer ml-3 relative"
                            }, [
                              _createVNode("div", {
                                class: "h-4 xxl:h-5 ml-2 img-close-icon",
                                onMouseenter: ($event: any) => (_ctx.isHoverEnter(index)),
                                onMouseleave: _cache[46] || (_cache[46] = ($event: any) => (_ctx.isHoverDelete = false))
                              }, [
                                _withDirectives(_createVNode(_component_Tooltip, {
                                  message: "Hapus Barang",
                                  title: "",
                                  footer: "",
                                  style: {"width":"135px","margin-left":"1.5em","margin-top":"-1.3em"}
                                }, null, 512), [
                                  [_vShow, _ctx.isHoverDelete && index === _ctx.cacheIndex]
                                ])
                              ], 40, ["onMouseenter"])
                            ], 8, ["onClick"]), [
                              [_vShow, 
                      _ctx.isShipmentCA ? (index > _ctx.detailShipment.shipmentGoodDetail.length-1) :
                      _ctx.disabledWeightAdjustment ? false : _ctx.listKGs.length > 1 &&
                        (!_ctx.isShipmentCASameday
                          ? !_ctx.isVendorNinja &&
                            !_ctx.isShipmentMp &&
                            !_ctx.isEnablePiecesBooking &&
                            !_ctx.configDisableC1
                          : false) || (_ctx.isShipmentCA)
                    ]
                            ])
                          ]))
                    ]),
                    _withDirectives(_createVNode("div", _hoisted_85, [
                      _hoisted_86,
                      _createVNode("div", _hoisted_87, [
                        _createVNode(_component_Icons, {
                          width: "16",
                          height: "16",
                          name: "announce",
                          class: "mr-2"
                        }),
                        _createVNode("p", _hoisted_88, " Berat diatas " + _toDisplayString(_ctx.minimumHeavyWeightSurcharge.heavyWeightMinimum) + " kg akan dikenakan biaya tambahan & Anda tidak dapat menambah koli lagi. ", 1)
                      ]),
                      _hoisted_89
                    ], 512), [
                      [_vShow, key.warningHwsSingle]
                    ]),
                    _withDirectives(_createVNode("div", _hoisted_90, [
                      _hoisted_91,
                      _createVNode("div", _hoisted_92, [
                        _hoisted_93,
                        _createVNode("p", _hoisted_94, " Berat mulai " + _toDisplayString(_ctx.minimumHeavyWeightSurcharge.heavyWeightMinimum) + " kg hanya 1 koli. Ubah berat atau booking baru. ", 1)
                      ]),
                      _hoisted_95
                    ], 512), [
                      [_vShow, key.isErrorHws]
                    ]),
                    (_ctx.isShipmentCA && _ctx.isDecreaseWeightNotAllowed)
                      ? (_openBlock(), _createBlock("div", _hoisted_96, [
                          _hoisted_97,
                          _hoisted_98,
                          _hoisted_99
                        ]))
                      : _createCommentVNode("", true),
                    _withDirectives(_createVNode("hr", _hoisted_100, null, 512), [
                      [_vShow, index > 0 || index == _ctx.listKGs.length - 1]
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          (_ctx.errorMessageChWeight)
            ? (_openBlock(), _createBlock("div", _hoisted_101, [
                _hoisted_102,
                (_ctx.isErrorMaxChWeightGoods || _ctx.isErrorMaxChWeightDimension)
                  ? (_openBlock(), _createBlock("span", _hoisted_103, " Total berat melebihi batas maksimum. Cek & atur ulang berat. "))
                  : (_openBlock(), _createBlock("span", _hoisted_104, " Berat kotor sudah melebihi batas berat, Anda tidak bisa ubah berat lagi. "))
              ]))
            : _createCommentVNode("", true),
          (_ctx.isShipmentCASameday && _ctx.totalChargeableWeight > 5)
            ? (_openBlock(), _createBlock("div", _hoisted_105, [
                _hoisted_106,
                _hoisted_107
              ]))
            : _createCommentVNode("", true),
          ((_ctx.dataDetailShipmentBooking?.config?.adjustPieceAdd?.rule === 'EDITABLE' && _ctx.isMaxAddKgs && !_ctx.disabledWeightAdjustment) ||
            (!_ctx.isShipmentCASameday
              ? _ctx.isMaxAddKgs &&
                !_ctx.isVendorNinja &&
                !_ctx.allowToAddMoreKoli &&
                !_ctx.allowToAddMoreKoliVolume &&
                !_ctx.isShipmentMp &&
                !_ctx.configDisableC1 &&
                !_ctx.disabledWeightAdjustment
              : false)
          )
            ? (_openBlock(), _createBlock("div", _hoisted_108, [
                _createVNode("div", {
                  onClick: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.addKGs && _ctx.addKGs(...args))),
                  class: 
              `flex gap-3 ${
                _ctx.dataDetailShipmentBooking?.config?.adjustPieceAdd?.rule === 'EDITABLE'
                  ? 'text-red-lp-300 cursor-pointer'
                  : (
                      _ctx.isDisableAdjustPieces ||
                      _ctx.disableAddPiecesHws ||
                      _ctx.disableAdjustPiecesC1orC2
                    )
                    ? 'text-gray-lp-600 cursor-not-allowed'
                    : 'text-red-lp-300 cursor-pointer'
              }`
            
                }, [
                  _createVNode(_component_Icons, {
                    name: "plus-circle",
                    class: 
                `${
                  _ctx.dataDetailShipmentBooking?.config?.adjustPieceAdd?.rule === 'EDITABLE'
                    ? 'text-red-lp-300'
                    : (
                        _ctx.isDisableAdjustPieces ||
                        _ctx.disableAddPiecesHws ||
                        _ctx.disableAdjustPiecesC1orC2
                      )
                      ? 'text-gray-lp-600'
                      : 'text-red-lp-300'
                }`
              
                  }, null, 8, ["class"]),
                  _hoisted_109
                ], 2)
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.onShowSectionAdjustmentWeight(
              _ctx.isCourierRecommendation
                ? _ctx.detailShipment.shipmentNoRefExt
                : _ctx.detailShipment.shipmentAlgoId
            ) &&
              _ctx.shipmentList[_ctx.indexElement].shipmentProduct.toLowerCase() !==
                'sameday'
          )
            ? (_openBlock(), _createBlock(_component_SectionUploadPhotoForWeightAdjusment, {
                key: 9,
                ref: "section-weight-adjustment",
                showViewAdjustment: _ctx.showViewAdjustment,
                "onUpdate:showViewAdjustment": _cache[48] || (_cache[48] = ($event: any) => (_ctx.showViewAdjustment = $event)),
                title: "Upload bukti foto untuk ubah berat",
                watermark: 
            _ctx.isCourierRecommendation
              ? _ctx.detailShipment.shipmentNoRefExt
              : _ctx.detailShipment.shipmentAlgoId
          ,
                modelValue: _ctx.attachmentImages,
                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (_ctx.attachmentImages = $event)),
                onOnUploadImage: _ctx.onUpload,
                onOnDeleteImage: _ctx.onRemove
              }, null, 8, ["showViewAdjustment", "watermark", "modelValue", "onOnUploadImage", "onOnDeleteImage"]))
            : _createCommentVNode("", true),
          _createVNode(_component_DataWrapper, {
            label: "Pilih jenis pengiriman",
            class: "w-full mr-4 mt-2"
          }, {
            default: _withCtx(() => [
              (_ctx.isEmbargoCommodity)
                ? (_openBlock(), _createBlock("div", _hoisted_110, [
                    _hoisted_111,
                    _hoisted_112
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_product_poster, {
                class: "mt-3",
                ref: "renderPoster",
                productType: 
              _ctx.shipmentList[_ctx.indexElement].shipmentProduct.toLowerCase() ===
              'jumbopackh2h'
                ? 'jumbopack'
                : _ctx.shipmentList[_ctx.indexElement].shipmentProduct.toLowerCase()
            ,
                isDisabledProduct: _ctx.isDisableProduct,
                onChoseeProduct: _ctx.onSelectProduct,
                onSetErrorTriggered: _ctx.setErrorDestintaionProductUpselling,
                isOnePack: true,
                isShipmentCod: _ctx.isShipmentCod,
                isJumboPack: 
              _ctx.shipmentList[_ctx.indexElement].shipmentProduct.toLowerCase() ===
                'jumbopack' ||
                _ctx.shipmentList[_ctx.indexElement].shipmentProduct.toLowerCase() ===
                  'jumbopackh2h'
            ,
                isSameday: _ctx.isShipmentCASameday,
                isEmbargo: _ctx.isEmbargoCommodity
              }, null, 8, ["productType", "isDisabledProduct", "onChoseeProduct", "onSetErrorTriggered", "isShipmentCod", "isJumboPack", "isSameday", "isEmbargo"]),
              (_ctx.errorProduct)
                ? (_openBlock(), _createBlock("div", _hoisted_113, [
                    _createVNode(_component_Icons, {
                      name: "warning-triangle",
                      class: " w-4"
                    }),
                    _createVNode("p", _hoisted_114, _toDisplayString(_ctx.errorProduct), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.productErrorDFOD)
                ? (_openBlock(), _createBlock("div", _hoisted_115, [
                    _createVNode(_component_Icons, {
                      name: "warning-triangle",
                      class: " w-4"
                    }),
                    _createVNode("p", _hoisted_116, _toDisplayString(_ctx.errorMsgProductDfod), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        (_ctx.isVendorNinja)
          ? (_openBlock(), _createBlock("div", _hoisted_117, " Untuk tujuan yang dipilih maksimal 1 koli "))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_118, [
          (
            _ctx.prefixAlgoEstimationShow(
              _ctx.shipmentList[_ctx.indexElement].shipmentAlgoId
            ) || _ctx.shipmentC1Cod
          )
            ? (_openBlock(), _createBlock(_component_DetailCalculation, {
                key: 0,
                isShowArrow: false,
                isShowWeightCost: true,
                isBooking: true,
                isDisabled: _ctx.isDisabledButton,
                bookingType: "shipment",
                payload: _ctx.payload,
                isPrintAble: _ctx.isPrintAble,
                algoId: _ctx.shipmentList[_ctx.indexElement].shipmentAlgoId,
                onUpdateStatusErrorEmbargo: _ctx.updateStatusErrorEmbargo,
                comodityCode: _ctx.shipmentList[_ctx.indexElement].shipmentCommodityCode,
                isVolumeWeight: _ctx.isVolumeWeight,
                isGrossWeight: _ctx.isGrossWeight,
                totalItem: _ctx.listKGs.length,
                totalGrossWeight: _ctx.totalGrossWeight,
                totalDimensionWeight: _ctx.totalVolumeWeight,
                chargeableWeight: _ctx.estimationPriceData.chargeableWeight,
                isCampaign: _ctx.isCampaign
              }, null, 8, ["isDisabled", "payload", "isPrintAble", "algoId", "onUpdateStatusErrorEmbargo", "comodityCode", "isVolumeWeight", "isGrossWeight", "totalItem", "totalGrossWeight", "totalDimensionWeight", "chargeableWeight", "isCampaign"]))
            : (_openBlock(), _createBlock(_component_DetailUncalculation, {
                key: 1,
                isShowArrow: false,
                isShowWeightCost: true,
                isBooking: true,
                isDisabled: _ctx.isDisabledButton,
                bookingType: "shipment",
                payload: _ctx.payload,
                isPrintAble: _ctx.isPrintAble,
                algoId: _ctx.shipmentList[_ctx.indexElement].shipmentAlgoId,
                onOnSelectProduct: _ctx.mountedProductUpsellingDefault,
                isVolumeWeight: _ctx.isVolumeWeight,
                isGrossWeight: _ctx.isGrossWeight,
                totalItem: _ctx.listKGs.length,
                totalGrossWeight: _ctx.totalGrossWeight,
                totalDimensionWeight: _ctx.totalVolumeWeight,
                chargeableWeight: _ctx.estimationPriceData.chargeableWeight,
                isCampaign: _ctx.isCampaign
              }, null, 8, ["isDisabled", "payload", "isPrintAble", "algoId", "onOnSelectProduct", "isVolumeWeight", "isGrossWeight", "totalItem", "totalGrossWeight", "totalDimensionWeight", "chargeableWeight", "isCampaign"]))
        ])
      ]),
      _: 1
    }, 8, ["title", "onClose"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: 
      () => {
        _ctx.resetForm();
        _ctx.setEditTerminated(false);
        _ctx.setModalDetailShipment(false);
      }
    ,
      onClose: () => _ctx.setEditTerminated(false),
      title: "Yakin ingin keluar?",
      message: "Perubahan data booking tidak akan tersimpan.",
      image: "badge-warning-lg",
      textSuccess: "Keluar",
      textCancel: "Tetap disini",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.closeModalError,
      title: _ctx.titleErrorspesification,
      message: _ctx.errorCause,
      image: "image-modal-warning",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message"]), [
      [_vShow, _ctx.isErrorAdd && _ctx.isErrorSpesificRate]
    ]),
    (_ctx.isErrorAdd && !_ctx.isErrorSpesificRate)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.errorCause,
          onCancel: _ctx.closeModalError,
          onTryAgain: _ctx.booking,
          modal: ""
        }, null, 8, ["errorType", "onCancel", "onTryAgain"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: "Pembuatan Booking Baru Berhasil !",
      message: `${this.messageSuccess}`,
      image: "image-modal-success",
      textSuccess: "OK",
      class: "px-8"
    }, {
      custom: _withCtx(() => [
        (_ctx.discount?.isDiscount)
          ? (_openBlock(), _createBlock(_component_card, {
              key: 0,
              isShadow: false,
              class: "mt-3"
            }, {
              default: _withCtx(() => [
                _hoisted_119,
                _createVNode("div", _hoisted_120, [
                  _createVNode("div", _hoisted_121, _toDisplayString(_ctx.formatPrice(_ctx.discount.totalTariff)), 1),
                  _createVNode("div", _hoisted_122, _toDisplayString(_ctx.formatPrice(_ctx.discount.totalAfterDiscount)), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ])
  ], 64))
}